import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, TextField, Stack, Card } from '@mui/material'
import useAuth from '../../hooks/useAuth'


export const ResetPasswordForm = ({ onClose }) => {
  
  const auth = useAuth()
  
  // STATES
  const [email, setEmail] = useState(null)
  
  const submit = e => {
    e.preventDefault()
    auth.resetPasswordAction(email)
  }
  
  return (
    <Card component='form' onSubmit={submit} id='resetPasswordForm' sx={{ p: 1 }}>
      <Stack position='relative'>
        <TextField
          required
          onChange={e => setEmail(e.target.value)}
          name='email'
          type='email'
          value={email || ''}
          label='Email'
          fullWidth
        />
        <Button type='submit' variant='contained' color='primary' fullWidth disabled={!email}>
          Recevoir le lien par email
        </Button>
        <Button variant='text' onClick={onClose}>Back to login</Button>
      </Stack>
    </Card>
  )
}

ResetPasswordForm.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default ResetPasswordForm
